import { Paths } from '@/types/routes';
import { HeaderLink } from '../general/HeaderLinks/HeaderLinks.component';

const CandidatesListHeader = [
  {
    to: Paths.CANDIDATES,
    label: 'List',
    active: false,
  },
  {
    to: Paths.CANDIDATES_BOARD,
    label: 'Board',
    active: false,
  },
];

const TalentPoolListHeader = [
  {
    to: Paths.TALENT_POOL,
    label: 'List',
    active: false,
  },
  {
    to: Paths.TALENT_POOL_BOARD,
    label: 'Board',
    active: false,
  },
];

const addStateToHeaderLinks = (
  headerLinks: HeaderLink[],
  state: Record<string, unknown>
): HeaderLink[] => {
  return headerLinks.map((link) => ({
    ...link,
    state,
  }));
};

export const getHeaderLinks = (pathname: string): HeaderLink[] => {
  const isAllCandidates = pathname.includes(Paths.CANDIDATES);

  let headerLinks: HeaderLink[] = [];

  if (isAllCandidates) {
    headerLinks = addStateToHeaderLinks(CandidatesListHeader, { isAllCandidates });
  } else {
    headerLinks = addStateToHeaderLinks(TalentPoolListHeader, { isAllCandidates });
  }

  const linksWithActiveProp = headerLinks.map((link) => ({
    ...link,
    active: link.to === pathname,
  }));

  return linksWithActiveProp;
};
